// extracted by mini-css-extract-plugin
module.exports = {"pagecontainer":"pagecontainer--1gOpV","page":"page--1RrO6","pagetitle":"pagetitle--2jpac"};